import { useLayoutEffect, useRef, useState } from "react";

export default function useCaseHomePanelsLayout(relationships, enabled) {
  const gridRef = useRef(null);
  const [counselOnOwnRow, setCounselOnOwnRow] = useState(false);

  useLayoutEffect(() => {
    const grid = gridRef.current;
    if (!enabled || !grid) return;

    const counselling = grid.querySelector(".case-home-grid-counselling");
    const names = Array.from(grid.querySelectorAll(".co-counsel-firm-name"));
    const photo = grid.querySelector(".case-home-grid-photo-1");
    const open = grid.querySelector(".case-home-grid-open");

    const updateLayout = () => {
      const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
      // Always measure the space in the shared layout, even while stacked,
      // so expanding the page can restore it without toggling back and forth.
      const sharedWidth =
        (grid.clientWidth -
          photo.getBoundingClientRect().width -
          open.getBoundingClientRect().width -
          gap * 3) /
        2;
      const panelWidth = counselling.getBoundingClientRect().width;
      const requiredWidths = names.map((name) => {
        const text = document.createRange();
        text.selectNodeContents(name);
        // A range gives the natural text width even when the name is ellipsized
        // or its flex box currently has more space than the text needs.
        return panelWidth - name.getBoundingClientRect().width + text.getBoundingClientRect().width;
      });

      setCounselOnOwnRow(requiredWidths.some((width) => width > sharedWidth));
    };

    let frame;
    const observer = new ResizeObserver(() => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(updateLayout);
    });
    observer.observe(grid);
    observer.observe(counselling);
    names.forEach((name) => {
      Array.from(name.parentElement.children).forEach((element) => observer.observe(element));
    });
    document.fonts.addEventListener("loadingdone", updateLayout);
    updateLayout();

    return () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
      document.fonts.removeEventListener("loadingdone", updateLayout);
    };
  }, [relationships, enabled]);

  return { gridRef, counselOnOwnRow };
}
